import api from './client';

export const createConversation = (recordId) =>
  api.post('/ai-chat/conversations', { recordId }).then(r => r.data);

export const getConversations = (recordId) =>
  api.get('/ai-chat/conversations', { params: { recordId } }).then(r => r.data);

export const getMessages = (conversationId) =>
  api.get(`/ai-chat/conversations/${conversationId}/messages`).then(r => r.data);

export const sendMessage = (conversationId, message, deepAnalysis = false) =>
  api.post(`/ai-chat/conversations/${conversationId}/messages`, { message, deepAnalysis }).then(r => r.data);

export const deleteConversation = (conversationId) =>
  api.delete(`/ai-chat/conversations/${conversationId}`).then(r => r.data);

export const getRecordStatus = (recordId) =>
  api.get(`/ai-chat/records/${recordId}/status`).then(r => r.data);

export const reindexRecord = (recordId) =>
  api.post(`/ai-chat/records/${recordId}/reindex`).then(r => r.data);

export const executeAction = (actionId, confirmed) =>
  api.post(`/ai-chat/actions/${actionId}`, { confirmed }).then(r => r.data);
